angular.module('taric.tradeMovement', [])
    .factory('tradeMovementService', require('./services/trade-movement'))
;